// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"72502ea9","453":"df3fdcfa"}[chunkId] + ".chunk.js";
};